/**
 * Google-style link styling for dual mode search
 * Makes links clearly clickable with dotted underline
 */
export const dualModeLinkStyles = {
    textDecorationLine: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationThickness: '10%',
    textUnderlineOffset: '12%',
    textDecorationColor: '#8b8c91',
    color: 'inherit',
    cursor: 'pointer',
    '&:hover': {
        textDecorationStyle: 'solid',
        textDecorationColor: '#3b82f6', // Primary blue on hover
    },
};
/**
 * MUI sx prop compatible link styles for dual mode
 */
export const getDualModeLinkSx = (dualModeEnabled = false) => {
    if (!dualModeEnabled) {
        return {
            textDecoration: 'none',
            color: 'inherit',
            cursor: 'pointer',
            '&:hover': {
                textDecoration: 'underline',
            },
        };
    }
    return {
        ...dualModeLinkStyles,
    };
};
//# sourceMappingURL=linkStyles.js.map